import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import UserService from "../../Services/UserService";
import doctorIcon from "../../assets/images/Svg/doctorIcon.svg";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";

const Calendar = () => {
  const today = dayjs();
  const [selectedDate, setSelectedDate] = useState(today);
  const [viewDate, setViewDate] = useState(today);
  const navigate = useNavigate();

  useEffect(() => {
    getDoctorsList();
  }, []);

  const daysInMonth = viewDate.daysInMonth();
  const startDayOfWeek = viewDate.startOf("month").day(); // Sunday=0
  const monthNames = dayjs.months();

  const handleMonthChange = (e) => {
    const monthIndex = monthNames.indexOf(e.target.value);
    setViewDate(viewDate.month(monthIndex));
  };

  const handleQuickSelect = (type) => {
    if (type === "today") {
      setSelectedDate(today);
      setViewDate(today);
    } else if (type === "last8") {
      // Custom logic — could be used for a range picker later
      setSelectedDate(today.subtract(7, "day"));
      setViewDate(today);
    } else if (type === "lastMonth") {
      const lastMonth = today.subtract(1, "month");
      setSelectedDate(null); // Reset if using range
      setViewDate(lastMonth);
    }
  };

  const renderBlankDays = () =>
    Array.from({ length: startDayOfWeek }).map((_, i) => (
      <div key={`blank-${i}`} />
    ));

  const renderDays = () =>
    Array.from({ length: daysInMonth }, (_, i) => {
      const day = i + 1;
      const isSelected =
        selectedDate &&
        viewDate.date(day).isSame(selectedDate, "day") &&
        viewDate.isSame(selectedDate, "month");

      return (
        <div
          key={day}
          onClick={() => setSelectedDate(viewDate.date(day))}
          className={`py-1 rounded-md cursor-pointer hover:bg-[#e0f7ff] ${
            isSelected ? "bg-[#189FAA] text-white" : ""
          }`}
        >
          {day}
        </div>
      );
    });
  const [loading, setLoading] = useState(true);
  const [doctors, setDoctors] = useState([]);

  const getDoctorsList = async () => {
    const userPayload = {
      displayInWebsite: "Y",
      status: 1,
      pageNo: 1,
      pageSize: 10,
    };

    setLoading(true);
    try {
      const response = await UserService.getDoctors(userPayload);
      const filterDoctors = response?.data?.filter(
        (item) => item.userType === "P" && item.videoFee && item.videoFee > 0
      );
      setDoctors(filterDoctors);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };
  const handleDoctorDetailsPage = (doctor) => {
    navigate(APP_ROUTES.DOCTORDETAILS, {
      state: { selectedDoctor: doctor },
    });
  };
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 w-full flex sm:flex-col gap-10 h-[30%] overflow-y-scroll scrollWidth">
      <div className="w-[60%] sm:w-full">
        <div className="flex justify-between gap-5 items-center mb-4">
          <div className="flex gap-2">
            <button
              className="px-4 py-1 bg-[#189FAA] text-white rounded-md text-xs font-sans font-semibold"
              onClick={() => handleQuickSelect("today")}
            >
              Today
            </button>
            {/* <button
              className="px-4 py-1 bg-[#f0f6fb] text-[#189FAA] rounded-md text-xs font-sans font-semibold"
              onClick={() => handleQuickSelect("last8")}
            >
              Last 8 days
            </button> */}
            <button
              className="px-4 py-1 bg-[#f0f6fb] text-[#189FAA] rounded-md text-xs font-sans font-semibold"
              onClick={() => handleQuickSelect("lastMonth")}
            >
              Last month
            </button>
          </div>
          <select
            className="text-xs font-sans font-semibold cursor-pointer border border-gray-300 rounded px-2 py-1 outline-none"
            value={monthNames[viewDate.month()]}
            onChange={handleMonthChange}
          >
            {monthNames.map((month, index) => (
              <option key={index} value={month}>
                {month}
              </option>
            ))}
          </select>
        </div>

        {/* Days of Week */}
        <div className="grid grid-cols-7 gap-2 text-center text-gray-500 text-sm mb-2">
          {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d, i) => (
            <div key={i}>{d}</div>
          ))}
        </div>

        {/* Calendar Days */}
        <div className="grid grid-cols-7 gap-2 text-center text-sm">
          {renderBlankDays()}
          {renderDays()}
        </div>

        {/* Footer Buttons */}
        {/* <div className="flex justify-end mt-4">
          <div className="flex gap-2">
            <button
              className="border border-[#189FAA] text-[#189FAA] rounded-md font-sans font-semibold px-3 py-1 text-sm"
              onClick={() => setSelectedDate(null)}
            >
              Clear
            </button>
            <button
              className="bg-[#189FAA] text-white px-3 py-1 rounded-md font-sans font-semibold text-sm"
              onClick={() =>
                alert(`Apply date: ${selectedDate?.format("YYYY-MM-DD")}`)
              }
            >
              Apply
            </button>
          </div>
        </div> */}
      </div>
      <div className="w-[40%] sm:w-full">
        <div className=" flex flex-col max-h-[300px]">
          <div className="flex justify-between items-center mb-2">
            <h2 className="text-base font-sans font-semibold text-[#189FAA]">
              Doctors
            </h2>
            <button
              onClick={() => {
                navigate(APP_ROUTES.CONSULTDOCTOR);
              }}
              className="text-sm font-sans font-semibold text-[#189FAA]"
            >
              View all
            </button>
          </div>
          <div className="flex overflow-x-scroll scrollWidth h-24 gap-1 px-4">
            {doctors.map((doctor, i) => (
              <img
                onClick={() => handleDoctorDetailsPage(doctor)}
                key={i}
                src={
                  doctor.imageName
                    ? `${process.env.REACT_APP_IMAGE_URL}${doctor.imageName}`
                    : doctorIcon
                }
                alt={`Doctor ${i + 1}`}
                className="w-8 h-8 rounded-full object-cover"
                title={
                  doctor?.salutation +
                  " " +
                  doctor?.firstName +
                  " " +
                  doctor?.lastName
                }
              />
            ))}
          </div>
          <div className="overflow-y-auto scrollWidth pr-1 mt-2 flex-1">
            {doctors &&
              doctors.map((doctor, i) => (
                <div
                  onClick={() => handleDoctorDetailsPage(doctor)}
                  key={i}
                  className="bg-[#f0f6fb] cursor-pointer rounded-md py-1 px-2 mb-2"
                >
                  <p className="text-sm text-[#189FAA] font-sans font-medium">
                    {doctor?.speciality}
                  </p>
                  <p className="text-xs font-semibold mt-1 font-sans">
                    {doctor?.salutation +
                      " " +
                      doctor?.firstName +
                      " " +
                      doctor?.lastName}
                  </p>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
